module.exports = __webpack_public_path__ + "static/img/P2.74e34fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wlzb/P2.png
// module id = 0QIv
// module chunks = 0